var map = {
	"./ABS.png": 51747,
	"./ATS.png": 75781,
	"./AmplifiID.png": 80692,
	"./TextureIcons/blotter_paper.svg": 24258,
	"./TextureIcons/capsule.svg": 27516,
	"./TextureIcons/cooker.svg": 64718,
	"./TextureIcons/crystal.svg": 94496,
	"./TextureIcons/flakes.svg": 28689,
	"./TextureIcons/liquid.svg": 47015,
	"./TextureIcons/other.svg": 47455,
	"./TextureIcons/pebbels2.svg": 88122,
	"./TextureIcons/powder.svg": 42192,
	"./TextureIcons/syringe_residue.svg": 71988,
	"./TextureIcons/tablet.svg": 27419,
	"./TextureIcons/wet_paste.svg": 57745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;